import {h, Fragment} from "preact"
export default function SubmitButton({ className, text, onClick}) {
    

    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ${className}`}>
            <button type="button" className="ns-act-btn ns-text-align-center ns-w-100" onClick={onClick}>
                {text}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M0.999532 6.99973H12.1695L7.28953 2.11973C6.89953 1.72973 6.89953 1.08973 7.28953 0.699727C7.67953 0.309727 8.30953 0.309727 8.69953 0.699727L15.2895 7.28973C15.6795 7.67973 15.6795 8.30973 15.2895 8.69973L8.69953 15.2897C8.30953 15.6797 7.67953 15.6797 7.28953 15.2897C6.89953 14.8997 6.89953 14.2697 7.28953 13.8797L12.1695 8.99973H0.999532C0.449532 8.99973 -0.000468254 8.54973 -0.000468254 7.99973C-0.000468254 7.44973 0.449532 6.99973 0.999532 6.99973Z" fill="white"/>
                </svg>
            </button>
        </div>
    )
}